import { Auth } from '@nackle/bridge';
import { idURL } from 'endpoints';
import { applyRequestMiddleware } from './utils/fetch';

const auth = new Auth( {
    authority: idURL
} );

export default auth;

applyRequestMiddleware( function( url, options ) {
    options.headers = {
        ...( options.headers || {} ),
        'company-id': auth.state.delegateCmp,
        'x-company-id': auth.state.delegateCmp
    };

    const accessToken = auth.state.access_token;

    if ( accessToken ) {
        options.headers.authorization = `Bearer ${ accessToken }`;
    }
} );

export function authRequestMiddleware ( url, options = {} ) {
    if ( !auth || !auth.state || !auth.state.claims ) {
        return;
    }

    const companyId = auth.state.claims.company_id;
    options.headers = {
        ...( options.headers || {} ),
        'company-id': companyId,
        'x-company-id': companyId,
        'person-id': auth.state.claims.person_id
    };

    const accessToken = auth.state.access_token;
    if ( accessToken ) {
        options.headers.authorization = `Bearer ${ accessToken }`;
    }
}

export function hasPermission( permission ) {
    const [ app, key ] = permission.split( '.', 2 );

    const userPermissions = auth?.state?.claims?.permissions;
    if ( !userPermissions ) {
        return false;
    }
    const appPermissions = userPermissions[ app ];
    if ( !Array.isArray( appPermissions ) ) {
        return false;
    }
    return appPermissions.includes( key );
}

export const permissions = {
    COMPANY_CREATE_COMPANY: 'company-service.create-company',
    COMPANY_DELETE_COMPANY: 'company-service.delete-company',

    COMPANY_EDIT_COMPANY: 'company-service.edit-company',
    COMPANY_READ_COMPANY: 'company-service.read-company',
    COMPANY_LIST_COMPANIES: 'company-service.list-companies'
};
